<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />

        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="d-flex flex-row">
                        <div class="flex-fill">
                            <label class="form-label">Modelo E-mail</label>
                            <vue-select v-model="modeloEmailSelected" :options="ModeloEmail" :label-by="formatNmModeloEmail"
                                placeholder="Selecione o modelo de E-mail" search-placeholder="Pesquise" searchable
                                close-on-select clear-on-select :min="1" class="form-control shadow-v2 "
                                :class="{ filled: modeloEmailSelected.idModeloEmail > 0 }">
                            </vue-select>
                        </div>
                        <div class="flex-fill ps-2">
                            <label class="form-label">Pessoa</label>
                            <vue-select :options="pessoa_instituicao" v-model="pessoa_instituicao_selects"
                                :label-by="(m) => (m.nmPessoa)" placeholder="Selecione a Pessoa" searchable
                                search-placeholder="Pesquise" close-on-select clear-on-select :min="1"
                                class="form-control shadow-v2" :class="{ filled: pessoa_instituicao_selects.length !== 0 }">
                            </vue-select>
                        </div>

                        <div v-if="modeloEmailSelected.idModeloEmail > 0" style="display: flex; align-items: flex-end;">
                            <button type="button" class="btn-new-crud btn-icon ms-2" @click="abreModalPreviewEmail()"><i
                                    class="fas fa-eye"></i></button>
                        </div>
                        <div v-if="modeloEmailSelected.idModeloEmail > 0" style="display: flex; align-items: flex-end;">
                            <button :disabled="enviarCrud.idPessoa == 0"  class="btn-new-crud ms-2" @click="func_crud('sendEmail')"><i class="fa fa-paper-plane"
                                    aria-hidden="true"></i><span class="btn-span-text">Enviar E-mail</span></button>
                        </div>
                    </div>
                </div>

                <div class="col-12 datatable-email mt-3">
                    <label class="form-label">Histórico</label>
                    <DataTable :url_ajax="getUrlModeloEmailEnvio()" :ajax_set_result="setHistorico"
                        @grid_refreshed="gridRefreshed" :refresh="refresh_grid" :filtros="filtro" method="GET"
                        :qtd_registros_por_pagina="20" :is_table="true" :footer_fixed="true" :headers="headers"
                        :pBtnsSlot="true" :is_modal="true"
                        :customHeightPaginate="lowHeightNoPage" :request_api="'comercial'"
                        :styleBotton="'bottom:0; left:0; margin-bottom:0;'"
                        :customHeight="lowHeightPage" :lineHeigthProp="''" />
                </div>
            </div>
        </div>

        <modal-warper target="preview_email" :show="isOpenModalEmailCrud" @close="(isOpenModalEmailCrud = false)">
            <Modal id="preview_email" :size="'modal-xl'" :open="isOpenModalEmailCrud" :FooterDefault="false"
                :ClassBG="true" customModalBody="min-height: calc(100vh - 8rem);overflow:auto;">
                <template v-slot:header>
                    <h6 class="modal-title">Visualização do Modelo de E-mail</h6>
                    <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()">
                        <i class="fas fa-times btn-close-style-v2 hover-effect"></i>
                    </button>
                </template>
                <template v-slot:body>
                    <div class="row">
                        <div class="row fundo-panel mt-3 ms-3 bg-white col-4" style="height: max-content !important;width: max-content !important;">
                            <span class="textInside" style="font-size: 24px;" v-html="htmModelo"></span>
                        </div>
                    </div>
                </template>
                <template v-slot:footer>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" data-bs-dismiss="modal"
                            @click="fecharModal()">
                            Fechar
                        </button>
                    </div>
                </template>
            </Modal>
        </modal-warper>

        <modal-warper target="ModalConfirmacao_enviar_email" :show="isOpenModalConfirmacaoSendEmail"
            @close="(isOpenModalConfirmacaoSendEmail = false)">
            <ModalConfirmacao id="enviar_email" :title="'Enviar Email'" :show="isOpenModalConfirmacaoSendEmail"
                :description="''" :red="'Enviar E-Mail?'" :action="'enviar'" @actionReturn="enviar" :isDelete="false" />
        </modal-warper>

    </div>
</template>
<script>

    import axios from 'axios';
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    import DataTable from '@/components/App/Datatable.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import Modal from '@/components/App/Modal.vue'
    import ModalConfirmacao from "@/components/App/ModalConfirmacao.vue";


    export default {
        name: 'Email',
        components: {
            'vue-select': VueNextSelect,
            DataTable,
            ModalWarper,
            OcorrenciaInfo,
            Modal,
            ModalConfirmacao
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                ocorrencia: { },
                dados: {},

                ModeloEmail: [],
                modeloEmailSelected: {},

                idModeloEmail: 0,
                nmModelo: '',
                htmModelo: '',
                idModulo: 0,

                refresh_grid: false,
                filtro: [
                    { active: true },
                ],

                pessoa_instituicao: [],
                pessoa_instituicao_selects: [],
                isOpenModalConfirmacaoSendEmail: false,

                headers: [
                    { class: 'col-2 row-content-top text-center', rowClass: 'mt-3 font-bold', name: 'nmModelo', text: 'Nome Modelo', order: 0 },
                    { class: 'col-2 row-content-top text-center', rowClass: 'mt-3', name: 'nmPessoa', text: 'Enviado Para', order: 0 },
                    { class: 'col-2 row-content-top text-center', rowClass: 'mt-3' , name: 'dtInclusaoString', text: 'Data De Envio', order: 0 },
                    { class: 'col', name: 'htmEnviado', rowClass: 'bg-light', text: '', order: 0 }
                ],

                enviarCrud: {
                    idModeloEmailEnvio: 1,
                    idModeloEmail: 0,
                    idPessoa: 0,
                    idInstituicao: 0,
                    idModulo: 0,
                    idOcorrencia: 0,
                    htmEnviado: ''
                },
                lowHeightPage: '',

                isOpenModalEmailCrud: false,
            }
        },
        computed: {
        },
        methods: {
            updateLowHeight() {
                if (window.innerWidth <= 1400) {
                    this.lowHeightPage = 'max-height: calc(100vh - 26.8rem);min-height: calc(100vh - 26.8rem);margin-top:0px !important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 27.6rem);min-height: calc(100vh - 27.6rem);margin-top:0px !important';
                }
                else if (window.innerWidth >= 1401) {
                    this.lowHeightPage = 'max-height: calc(100vh - 26.8rem); min-height: calc(100vh - 26.8rem); margin-top: 0px!important';
                    this.lowHeightNoPage = 'max-height: calc(100vh - 27.6rem);min-height: calc(100vh - 27.6rem);margin-top:0px !important';
                }
            },
            func_crud(tpAlteracao) {
                if (tpAlteracao == 'sendEmail') {
                    this.isOpenModalConfirmacaoSendEmail = true;
                }
            },
            getPessoa() {
                let $this = this;

                $this.pessoa_instituicao = [];

                if ($this.ocorrencia.idPessoa > 0) {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Pessoa/GetPessoaById?id=" + $this.ocorrencia.idPessoa,
                        {
                            headers: $this.$api.getTokenComercial()
                        }
                    ).then((response) => {
                        var array = [response.data.data];
                        $this.pessoa_instituicao = array;
                    });
                }
                else {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/PessoaInstituicao/GetPessoasInstituicao?idInstituicao=" + $this.ocorrencia.idInstituicao,
                        {
                            headers: $this.$api.getTokenComercial(),
                            params: "",
                        }
                    ).then((response) => {
                        $this.pessoa_instituicao = response.data.data;
                    });
                }          
            },
            formatNmModeloEmail(modeloEmail) {
                return modeloEmail.nmModelo;
            },
            getOcorrencia() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    this.getModeloEmail();
                    this.getPessoa();
                })
            },
            getModeloEmail() {
                let $this = this;

                $this.idModulo = $this.ocorrencia.idModulo;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmail/Get?idModulo=' + $this.idModulo + '&idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial()                    
                }).then(response => {
                    $this.ModeloEmail = response.data.data.rows;
                })

            },
            gridRefreshed(data_ajax) {
                let $this = this;

                $this.refresh_grid = false;
            },
            reloadGrid() {
                let $this = this;

                $this.refresh_grid = true;
            },
            abreModalPreviewEmail() {
                this.isOpenModalEmailCrud = true;
            },
            previewEmail(id) {
                let $this = this;

                $this.idModeloEmail = id.idModeloEmail;
                $this.nmModelo = id.nmModelo;
                //$this.htmModelo = id.htmModelo;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmail/GetPreviewModeloTicket?idModeloEmail=' + $this.idModeloEmail + '&idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    $this.htmModelo = response.data.data.htmModelo;
                })

            },
            getUrlModeloEmailEnvio() {
                let $this = this;

                return process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmailEnvio/GetModeloEmailHistoricoTicket?' + 'idModulo=' + $this.idModulo + '&idModeloEmail=' + $this.modeloEmailSelected.idModeloEmail + '&idOcorrencia=' + $this.idOcorrencia;
            },
            setHistorico(result) {
                return result;
            },
            enviar() {
                let $this = this;

                $this.enviarCrud.idModeloEmailEnvio = 0;
                $this.enviarCrud.idModeloEmail = $this.modeloEmailSelected.idModeloEmail;
                // $this.enviarCrud.idPessoa = $this.ocorrencia.idPessoa;
                $this.enviarCrud.idInstituicao = $this.ocorrencia.idInstituicao;
                $this.enviarCrud.idModulo = $this.ocorrencia.idModulo;
                $this.enviarCrud.idOcorrencia = $this.idOcorrencia;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/ModeloEmailEnvio/PostModeloEmailTicket', $this.enviarCrud, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        $this.reloadGrid();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
            },
            zerarInformacoes() {

            },
            fecharModal() {
                this.zerarInformacoes();
            },
            setActionCard(action) {
                this.$emit('setActionCard', action);
            },
        },
        created() {
        },
        mounted() {
            this.getOcorrencia();
            this.updateLowHeight();

            window.addEventListener('resize', this.updateLowHeight);
        },
        updated() {
            this.updateLowHeight();
        },
        watch: {
            idOcorrencia(newVal, oldVal) {

                this.getOcorrencia(newVal);
                this.getModeloEmail(newVal);
            },
            modeloEmailSelected(newVal, oldVal) {
                this.reloadGrid();
                this.previewEmail(newVal)
            },
            pessoa_instituicao_selects(newVal, oldVal) {
                this.enviarCrud.idPessoa = newVal.idPessoa;
            },
        },
    }

</script>

<style scope lang="scss">
    .textInside {
        p {
            span {
                span {
                    font-size: 14px;
                }
            }
        }
    }

    .datatable-email .body-class-personalizada {
        height: calc(100vh - 34rem);
    }

    .btn-icon {
        width: 47px;
    }
</style>